import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LinkUtilService {
  /**
   * Check if a URL is internal to our domain
   */
  isInternalLink(url: string): boolean {
    try {
      // Handle relative URLs (always internal)
      // But exclude protocol-relative URLs (//example.com)
      if (url.startsWith('//')) {
        // Protocol-relative URL, treat as external
        return false;
      }
      if (url.startsWith('/') || url.startsWith('#') || url.startsWith('?')) {
        return true;
      }

      // Parse absolute URLs
      const urlObj = new URL(url, window.location.origin);
      const hostname = urlObj.hostname;

      // Quick check: same hostname as current page
      if (hostname === window.location.hostname) {
        return true;
      }

      // Extract hostname from environment.webDomain
      const envDomain = new URL(environment.webDomain).hostname;

      // Check against internal domains (supports wildcards via endsWith)
      const internalDomains = [
        envDomain,
        'nonunbub.com',
        'www.nonunbub.com',
        'test.nonunbub.com',
        'amplifyapp.com',
        'localhost',
        '127.0.0.1',
      ];

      return internalDomains.some((domain) => hostname === domain || hostname.endsWith('.' + domain));
    } catch (e) {
      return false;
    }
  }

  /**
   * Fix link rel attributes in HTML content for display
   * Internal links: rel="noopener"
   * External links: rel="noopener noreferrer"
   */
  fixLinkAttributes(html: string): string {
    if (!html || !html.includes('<a')) {
      return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const links = doc.querySelectorAll('a');

    links.forEach((link) => {
      const href = link.getAttribute('href');
      if (!href) return;

      const isInternal = this.isInternalLink(href);

      // Set target if not already set
      if (!link.getAttribute('target')) {
        link.setAttribute('target', '_blank');
      }

      // Set appropriate rel attribute
      if (isInternal) {
        link.setAttribute('rel', 'noopener');
      } else {
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });

    return doc.body.innerHTML;
  }
}
